var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({ref:"anchor",tag:"component",class:_vm.classes,nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},'component',{
    to: _vm.action,
    ..._vm.routerLinkClasses,
    ..._vm.$attrs,
  },false),[_vm._t("default",function(){return [(_vm.icon && _vm.alignment === 'left')?_c('Icon',_vm._b({staticClass:"elder__navigation-component-icon-left"},'Icon',_vm.iconComp,false)):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.icon && _vm.alignment === 'right')?_c('Icon',_vm._b({staticClass:"elder__navigation-component-icon-right"},'Icon',_vm.iconComp,false)):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }